module.exports = __webpack_public_path__ + "img/icon_unselected_laohu.86af5362.png";